import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPlusLargeComponent } from "./med-icon-plus-large.component";

@NgModule({
  declarations: [
    MedIconPlusLargeComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPlusLargeComponent,
  ],
})
export class MedIconPlusLargeModule { }
